import { _t } from "./translation";

/**
 * Parses API GraphQL errors and returns user-friendly error messages
 */

// Error code to user-friendly message mapping
const ERROR_MESSAGES: Record<string, string> = {
  "GQL_ERR.PAYMENTS.VERIFICATION_FAILED":
    "The MFA code you entered is invalid. Please check your authenticator app and try again.",
};

const OZOW_ESTIMATE_QUOTE_ERROR_CODES: Record<string, string> = {
  "GQL_ERR.CONVERSIONS.TARGET_BASE_CURRENCY_AMOUNT_LESS_THAN_MIN_AMOUNT":
    "DEPOSIT_FORM.CONVERSION_QUOTE_MIN_AMOUNT_ERROR",
  "GQL_ERR.CONVERSIONS.SRC_QUOTE_CURRENCY_AMOUNT_EXCEEDS_MAX_AMOUNT":
    "DEPOSIT_FORM.CONVERSION_QUOTE_MAX_AMOUNT_ERROR",
};

/**
 * Parses API error and returns a user-friendly message
 * @param err - The error object from API call
 * @param defaultMessage - Default message if no specific error is found
 * @returns User-friendly error message
 */
export const parseApiError = (
  err: any,
  defaultMessage: string = "Something went wrong. Please try again or contact support."
): string => {
  const errorCode = err?.response?.errors?.[0]?.extensions?.code;

  return ERROR_MESSAGES[errorCode] || defaultMessage;
};

/**
 * Parses Ozow estimate quote REST errors into user-friendly i18n messages
 */
export const parseOzowEstimateQuoteError = (err: unknown): string => {
  const errorCode =
    err && typeof err === "object" && "code" in err && typeof (err as { code: unknown }).code === "string"
      ? (err as { code: string }).code
      : undefined;
  const i18nKey = errorCode ? OZOW_ESTIMATE_QUOTE_ERROR_CODES[errorCode] : undefined;

  return i18nKey ? _t(i18nKey) : _t("DEPOSIT_FORM.CONVERSION_QUOTE_ERROR");
};
